import { gql, useQuery } from '@apollo/client';

export const GET_APPLICATIONS_SETTING_BY_ID = gql`
  query getApplicationsSettingById($id: String!) {
    getApplicationsSettingById(id: $id) {
      type
      email
      _id
      companyId
      eAUTemplateAcceptedId
      eAUTemplateId
      eAUTemplateRejectedId
      rejectReasons {
        reason
        rejectValue
      }
    }
  }
`;

export const useGetApplicationsSettingById = (id?: string) => {
  const { data, loading } = useQuery(GET_APPLICATIONS_SETTING_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const salaryType = data?.getApplicationsSettingById || {};

  return { salaryType, loading };
};
